import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface ISamlConfiguration {
    UserId?: number;
    AccountId?: number;

    Domain: string;
    Endpoint: string;
    EntityId: string;
    Certificate: string;

    VerificationStatus?: SamlConfigurationVerificationStatus;
    Status?: SamlConfigurationStatus;
    VerificationIdentifier?: string;
    VerificationTime?: Date;
    AssertionConsumerUrl?: string;
}

export enum SamlConfigurationStatus {
    Testing,
    Active,
    Inactive
}

export enum SamlConfigurationVerificationStatus {
    Requested,
    Verified
}

@Injectable()
export class SamlService {

    constructor(
        private readonly http: HttpClient) {
    }

    getConfiguration(): Observable<ISamlConfiguration> {
        return this.http.get<ISamlConfiguration>(`/api/sso/configuration`);
    }

    saveConfiguration(config: ISamlConfiguration): Observable<any> {

        if (!config.VerificationIdentifier) {
            return this.createInitialConfiguration(config);
        }

        return this.http.post(`/api/sso/configuration`, config);
    }

    validateTXTRecord(domain: string): Observable<any> {
        const formData = new FormData()
        formData.append("domain", domain);

        return this.http.post("/api/sso/configuration/verify", formData);
    }

    private createInitialConfiguration(config: ISamlConfiguration): Observable<any> {
        return this.http.post(`/api/sso/configuration`, config);
    }
}
